window.addEventListener('load', function() {
    if (document.querySelector('.start_calendar')) {
        const second = 1000, minute = second * 60, hour = minute * 60, date = hour * 24;

        let endYear = parseInt(document.querySelector('.event_year').dataset.value);
        let endMonth = parseInt(document.querySelector('.event_month').dataset.value);
        let endDate = parseInt(document.querySelector('.event_date').dataset.value);
        let endHour = parseInt(document.querySelector('.event-end-hour').dataset.value);

        let startYear = parseInt(document.querySelector('.event_year').dataset.startValue);
        let startMonth = parseInt(document.querySelector('.event_month').dataset.startValue);
        let startDate = parseInt(document.querySelector('.event_date').dataset.startValue);
        let startHour = parseInt(document.querySelector('.event-end-hour').dataset.startValue);
        
        let countDown = new Date(endYear, endMonth, endDate, endHour).getTime();
        let startDown = new Date(startYear, startMonth, startDate, startHour).getTime();

        const x = setInterval(function() {
            const currentDate = new Date();
            const formattedDate = currentDate.toLocaleString("en-US", { timeZone: "PST" });
            const nowtime = new Date(formattedDate).getTime();

            let startTimer = startDown - nowtime;
            if (startTimer < 0) {
                document.querySelector('.custom-timer-wrapper').classList.remove('hidden');
                const distance = countDown - nowtime;
                if (distance > 0) {
                    const totalDays = Math.floor(distance / date);
                    const remainingHours = Math.floor((distance % date) / hour);
                    const remainingMinutes = Math.floor((distance % hour) / minute);
                    const remainingSeconds = Math.floor((distance % minute) / second);

                    document.querySelectorAll('.hc_cd_timernum').forEach(item => {
                        item.classList.remove('hidden');
                    });
                    document.querySelectorAll('.timer_loading').forEach(item => {
                        item.classList.add('hidden');
                    });

                    // Update days, hours, minutes, seconds
                    document.querySelectorAll('.js-timer-days').forEach(item => item.innerText = totalDays);
                    document.querySelectorAll('.js-timer-hours').forEach(item => item.innerText = remainingHours);
                    document.querySelectorAll('.js-timer-minutes').forEach(item => item.innerText = remainingMinutes);
                    document.querySelectorAll('.js-timer-seconds').forEach(item => item.innerText = remainingSeconds);
                } else {
                    document.querySelector('.custom-timer-wrapper').classList.add('hidden');
                    clearInterval(x); // Stop the interval when countdown ends
                }
            }
        }, second);

        // Optional: Update remaining time for today if you want separate logic
        function updateRemainingTime() {
            const now = new Date().toLocaleString("en-US", { timeZone: "PST" });
            const nowDate = new Date(now);

            const endOfDay = new Date(nowDate);
            endOfDay.setHours(23, 59, 59, 999);

            const remainingTime = endOfDay - nowDate;

            if (remainingTime > 0) {
                const totalDays = 0; // only today remaining, so 0
                const hours = Math.floor(remainingTime / hour);
                const minutes = Math.floor((remainingTime % hour) / minute);
                const seconds = Math.floor((remainingTime % minute) / second);

                document.querySelectorAll('.js-timer-days').forEach(item => item.innerText = totalDays);
                document.querySelectorAll('.js-timer-hours').forEach(item => item.innerText = hours);
                document.querySelectorAll('.js-timer-minutes').forEach(item => item.innerText = minutes);
                document.querySelectorAll('.js-timer-seconds').forEach(item => item.innerText = seconds);
            }
        }
    }
});
